import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import IncomePlan from './pages/Incomeplan';
import Terms from './pages/Terms';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/dashboard/Dashboard';
import MyPackage from './pages/dashboard/MyPackage';
import Deposit from './pages/dashboard/Deposit';
import UserWallet from './pages/dashboard/Wallet';
import Income from './pages/dashboard/Income';
import Team from './pages/dashboard/Team';
import Withdraw from './pages/dashboard/Withdraw';
import Profile from './pages/dashboard/Profile';
import Kyc from './pages/dashboard/Kyc';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminDeposits from './pages/admin/AdminDeposits';
import AdminPackages from './pages/admin/AdminPackages';
import AdminWithdrawals from './pages/admin/AdminWithdrawals';
import AdminIncome from './pages/admin/AdminIncome';
import AdminKyc from './pages/admin/AdminKyc';
import AdminRoiSettings from './pages/admin/AdminRoiSettings';
import AdminWithdrawalSettings from './pages/admin/AdminWithdrawalSettings';
import AdminTrading from './pages/admin/AdminTrading';
import AdminReward from './pages/admin/AdminReward';
import AdminTeam from './pages/admin/AdminTeam';
import AdminCMS from './pages/admin/AdminCMS';
import AdminReports from './pages/admin/AdminReports';
import AdminGeneralSettings from './pages/admin/AdminGeneralSettings';
import AdminWallet from './pages/admin/AdminWallet';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} replace /> : children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/services" element={<Services />} />
      <Route path="/income" element={<IncomePlan />} />
      <Route path="/terms" element={<Terms />} /> 
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
      <Route path="/register/:refCode" element={<PublicRoute><Register /></PublicRoute>} />
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/dashboard/package" element={<PrivateRoute><MyPackage /></PrivateRoute>} />
      <Route path="/dashboard/deposit" element={<PrivateRoute><Deposit /></PrivateRoute>} />
      <Route path="/dashboard/wallet" element={<PrivateRoute><UserWallet /></PrivateRoute>} />
      <Route path="/dashboard/income" element={<PrivateRoute><Income /></PrivateRoute>} />
      <Route path="/dashboard/team" element={<PrivateRoute><Team /></PrivateRoute>} />
      <Route path="/dashboard/withdraw" element={<PrivateRoute><Withdraw /></PrivateRoute>} />
      <Route path="/dashboard/kyc" element={<PrivateRoute><Kyc /></PrivateRoute>} />
      <Route path="/dashboard/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
      <Route path="/admin/deposits" element={<AdminRoute><AdminDeposits /></AdminRoute>} />
      <Route path="/admin/packages" element={<AdminRoute><AdminPackages /></AdminRoute>} />
      <Route path="/admin/withdrawals" element={<AdminRoute><AdminWithdrawals /></AdminRoute>} />
      <Route path="/admin/income" element={<AdminRoute><AdminIncome /></AdminRoute>} />
      <Route path="/admin/kyc" element={<AdminRoute><AdminKyc /></AdminRoute>} />
      <Route path="/admin/roi-settings" element={<AdminRoute><AdminRoiSettings /></AdminRoute>} />
      <Route path="/admin/withdrawal-settings" element={<AdminRoute><AdminWithdrawalSettings /></AdminRoute>} />
      <Route path="/admin/trading" element={<AdminRoute><AdminTrading /></AdminRoute>} />
      <Route path="/admin/reward" element={<AdminRoute><AdminReward /></AdminRoute>} />
      <Route path="/admin/team" element={<AdminRoute><AdminTeam /></AdminRoute>} />
      <Route path="/admin/cms" element={<AdminRoute><AdminCMS /></AdminRoute>} />
      <Route path="/admin/reports" element={<AdminRoute><AdminReports /></AdminRoute>} />
      <Route path="/admin/general-settings" element={<AdminRoute><AdminGeneralSettings /></AdminRoute>} />
      <Route path="/admin/wallet-management" element={<AdminRoute><AdminWallet /></AdminRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          theme="dark"
          style={{ zIndex: 99999 }}
        />
      </AuthProvider>
    </Router>
  );
}

export default App;